import { render, staticRenderFns } from "./courseDeclaration.vue?vue&type=template&id=1bbb3f9f&scoped=true"
import script from "./courseDeclaration.vue?vue&type=script&lang=js"
export * from "./courseDeclaration.vue?vue&type=script&lang=js"
import style0 from "./courseDeclaration.vue?vue&type=style&index=0&id=1bbb3f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb3f9f",
  null
  
)

export default component.exports